/**
 * New Lead entry control — opens Manual lead form or AI Intake (paste/message).
 * Single Add icon; label is "New Lead" (no literal "+") to avoid ++ UI.
 */

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Menu, MenuItem, ListItemText } from "@mui/material";
import { Add, ArrowDropDown } from "@mui/icons-material";
import { useAuth } from "@/contexts/AuthContext.jsx";

/**
 * @param {Object} props
 * @param {"small"|"medium"|"large"} [props.size]
 * @param {Object} [props.sx]
 * @param {string} [props.className]
 */
const NewLeadEntryButton = ({ size = "medium", sx, className }) => {
  const navigate = useNavigate();
  const { hasPermission } = useAuth();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  if (!hasPermission("leads:create")) {
    return null;
  }

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const goManual = () => {
    handleClose();
    navigate("/leads/new");
  };

  const goIntake = () => {
    handleClose();
    navigate("/leads/intake");
  };

  return (
    <>
      <Button
        variant="contained"
        size={size}
        startIcon={<Add />}
        endIcon={<ArrowDropDown />}
        onClick={handleOpen}
        aria-haspopup="menu"
        aria-expanded={open ? "true" : undefined}
        aria-controls={open ? "new-lead-entry-menu" : undefined}
        className={className}
        sx={{
          textTransform: "none",
          fontWeight: 600,
          whiteSpace: "nowrap",
          ...sx,
        }}
      >
        New Lead
      </Button>
      <Menu
        id="new-lead-entry-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MenuItem onClick={goManual}>
          <ListItemText
            primary="Manual lead"
            secondary="Fill the lead form yourself"
          />
        </MenuItem>
        <MenuItem onClick={goIntake}>
          <ListItemText
            primary="From message / AI Intake"
            secondary="Paste email or WhatsApp text"
          />
        </MenuItem>
      </Menu>
    </>
  );
};

export default NewLeadEntryButton;
